/* ==========================================================================
	Slider
	========================================================================= */

	var slider = require("./slider");

	$(".slider-trigger").on("click", slider);
	$(".slider-close").on("click", slider);
	$(".slider-open").on("click", slider);

/* ======================================================================
	Slider Nav
	===================================================================== */

	var drawerSlider = require("./drawer-nav");
	var nav = new drawerSlider({
	  group: ".drawer-nav",
	  triggers: [".primary-nav-trigger"]
	});
	nav.attachClick();

/* ==========================================================================
	Mobile Tester
	========================================================================= */

	var isSmall = function() {
		return $(window).width() < 1000;
	};

/* ======================================================================
	Enhanced Select placeholder
	===================================================================== */

	var toggleSelectState = function(event) {
		$selected = $(this).find(":selected");
		$(this).toggleClass("selected", !$selected.hasClass("gf_placeholder"));
	}

	$(".gfield_select").on("change ready", toggleSelectState);
	$(".ginput_container_select select").on("change ready", toggleSelectState);

/* ======================================================================
	Labels as Placeholders Helper
	===================================================================== */

	$(".placeholder-label-form").find("input").on("focus", function() {
		$(this).closest("p").addClass("active");
	});

	$(".placeholder-label-form").find("input").on("blur", function() {
		$(this).val() == "" && $(this).closest("p").removeClass("active");
	});

/* ======================================================================
	Icon Nav Activation Types
	===================================================================== */

	$(".locator-view-nav .nav-link").on("click", function() {
		$(".locator-view-nav .active").removeClass("active");
		$(this).closest(".nav-item").addClass("active");
	});

/* ======================================================================
	Star Rating
	===================================================================== */


	var zeroStar = $("<span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span>");
	var oneStar = $("<span class=\" fa fa-star checked\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span>");
	var twoStar = $("<span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span>");
	var threeStar = $("<span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star\"></span><span class=\" fa fa-star\"></span>");
	var fourStar = $('<span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star\"></span>');
	var fiveStar = $('<span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span><span class=\" fa fa-star checked\"></span>');

	$(".rating-0").append(zeroStar);
	$(".rating-1").append(oneStar);
	$(".rating-2").append(twoStar);
	$(".rating-3").append(threeStar);
	$(".rating-4").append(fourStar);
	$(".rating-5").append(fiveStar);
